import React from 'react';

import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
} from 'react-icons/fa';

// Import du module CSS
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>

      <div className={styles.address}>
        <p>
          Adresse : 05 Boulevard Mellah Ali Hai Sidi El Bachir ex Marceau Plateau Oran, 31021
        </p>
      </div>
      <div className={styles.contact}>
        <p>
          N° RC : 31/00 – 0120099 B24
        </p>
    
      </div>
      <div className={styles.socialMedia}>
        <a
          href="https://www.facebook.com/profile.php?id=61575500164221"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.icon}
        >
          <FaFacebook />
        </a>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.icon}
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.tiktok.com/@bkboexpat"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.icon}
        >
          <FaTiktok />
        </a>
      </div>
      <div className={styles.copyright}>
        <p>© 2024 BKBO. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
